"use client";

import { ChevronRight } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

export function ApiResponseGroup({
  code,
  description,
  defaultOpen,
  children,
}: {
  code: string;
  description?: string;
  defaultOpen: boolean;
  children: React.ReactNode;
}) {
  return (
    <Collapsible className="api-response" defaultOpen={defaultOpen}>
      <CollapsibleTrigger className="api-response-trigger">
        <ChevronRight className="api-response-chevron" size={16} aria-hidden />
        <span className="api-status">{code}</span>
        <span className="flex-1 text-left">{description}</span>
        <span className="api-type-label">application/json</span>
      </CollapsibleTrigger>
      <CollapsibleContent className="api-response-collapse">
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
}
